import React, { useState } from 'react';
import dayjs from 'dayjs';
import {
    LeftOutlined, // Ant Design left icon
    RightOutlined, // Ant Design right icon
} from "@ant-design/icons";
import 'dayjs/locale/zh-cn';
import CustomTitle from './CustomTitle';
import CustomInput from './CustomInput';
import CustomParagraph from './CustomParagraph';
import { Calendar, Col, Row, Select, Button } from 'antd';
import CustomButton from './CustomButton';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
//dayjs.extend(dayLocaleData);
dayjs.extend(isSameOrAfter); 
const CustomizeFilterCalendar = ({handleDataFromChild}) => {
    const [rangeStart, setRangeStart] = useState(null);
    const [rangeEnd, setRangeEnd] = useState(null);
    const [error, setError] = useState(false);

    const onPanelChange = (value, mode) => {
    };

    const onDateChange = (val) => {
        setError(false);
            if (!rangeStart) {
                setRangeStart(val.format('YYYY-MM-DD'))
            } else if (!rangeEnd) {
                if (dayjs(val).isSameOrAfter(dayjs(rangeStart), 'day')) {
                    setRangeEnd(val.format('YYYY-MM-DD'))
                } else {
                    setError(true);
                }
            } else {
                setRangeEnd(null);
                setRangeStart(val.format('YYYY-MM-DD'));
            }
    }

    const sendDataToParent = ()=>{
       let rangeModle={
        rangeStart:rangeStart,
        rangeEnd:rangeEnd
       }
       handleDataFromChild(rangeModle)
    }

    const wrapperStyle = {
        width: 300,
        border: '0px',
        borderRadius: '0px',
    };

    return (
        <div style={wrapperStyle}>
            <Calendar
                fullscreen={false}
                headerRender={({ value, onChange }) => {
                    const start = 0;
                    const end = 12;
                    const monthOptions = [];

                    let current = value.clone();
                    const localeData = value.localeData();
                    const months = [];
                    for (let i = 0; i < 12; i++) {
                        current = current.month(i);
                        months.push(localeData.monthsShort(current));
                    }



                    for (let i = start; i < end; i++) {
                        monthOptions.push(
                            <Select.Option key={i} value={i} className="month-item">
                                {months[i]}
                            </Select.Option>,
                        );
                    }


                    const handlePrev = () => {
                        const newValue = value.clone().subtract(1, "month"); // Subtract one month from the current value
                        onChange(newValue); // Update the calendar to the new value
                    };

                    const handleNext = () => {
                        const newValue = value.clone().add(1, "month"); // Add one month to the current value
                        onChange(newValue); // Update the calendar to the new value
                    };

                    const year = value.year();
                    const month = value.month();
                    const options = [];
                    for (let i = year - 10; i < year + 10; i += 1) {
                        options.push(
                            <Select.Option key={i} value={i} className="year-item">
                                {i}
                            </Select.Option>,
                        );
                    }
                    return (
                        <div style={{ padding: 8 }}>
                            <Row gutter={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Col>
                                    <Button
                                        type="text"
                                        icon={<LeftOutlined />}
                                        onClick={handlePrev}
                                    />
                                    <Select
                                        size="small"
                                        popupMatchSelectWidth={false}
                                        value={month}
                                        onChange={(newMonth) => {
                                            const now = value.clone().month(newMonth);
                                            onChange(now);
                                        }}
                                    >
                                        {monthOptions}
                                    </Select>
                                </Col>
                                <Col>
                                    <Select
                                        size="small"
                                        popupMatchSelectWidth={false}
                                        className="my-year-select"
                                        value={year}
                                        onChange={(newYear) => {
                                            const now = value.clone().year(newYear);
                                            onChange(now);
                                        }}
                                    >
                                        {options}
                                    </Select>
                                    <Button
                                        type="text"
                                        icon={<RightOutlined />}
                                        onClick={handleNext}
                                    />
                                </Col>



                            </Row>

                        </div>
                    );
                }}
                onSelect={onDateChange}
                //onPanelChange={}
            />
            <Row style={{ margin: "0px", display: "Flex", justifyContent: "space-between", alignItems: "center" }}>
                <Col span={11}>
                    <CustomTitle text={"Range start"} color="#000" fontSize="12px" lineHeight="28px" fontWeight="500" marginBottom={0} />
                    <CustomInput
                        placeholder="yyyy/mm/dd"
                        height="36px"
                        width="100%"
                        border="0px"
                        bgColor="#F3F3F3"
                        textColor="#5E5E5E"
                        borderRadius="8px"
                        placeholderColor="#5E5E5E"
                        lineHeight="38px"
                        value={rangeStart}
                    />
                </Col>
                <Col span={11}>
                    <CustomTitle text={"Range end"} color="#000" fontSize="12px" lineHeight="28px" fontWeight="500" marginBottom={0} />
                    <CustomInput
                        placeholder="yyyy/mm/dd"
                        height="36px"
                        width="100%"
                        border="0px"
                        bgColor="#F3F3F3"
                        textColor="#5E5E5E"
                        borderRadius="8px"
                        placeholderColor="#5E5E5E"
                        lineHeight="38px"
                        value={rangeEnd}
                    />
                </Col>
                {error && (
                    <Col span={24}>
                        <CustomParagraph text={"Range start must be less than range end"} color="#ff4d4f" fontSize="12px" fontWeight="400" lineHeight="28px" marginBottom={0} />
                    </Col>
                )}
                <Col style={{marginTop:"12px",display:"flex",justifyContent:"end",width:"100%"}}>
                <CustomButton text="Apply" onClick={sendDataToParent} width={62} height={36} bgColor="#000" color="#fff" fontSize={12} fontWeight={500} borderRadius={8} boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)" />
                </Col>
            </Row>
        </div>
    );
};

export default CustomizeFilterCalendar;